<template>
  <div class="newsItem">
    <!-- 产品详情 -->
    <PcProductItem class="PC"/>
    <MdProductItem class="MD"/>
  </div>
</template>

<script>
// 移动端
import MdProductItem from './MdProductItem.vue'
// pc端
import PcProductItem from './PcProductItem.vue'
export default {
  name: 'newsMain',
  components: {
    MdProductItem,
    PcProductItem
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsItem{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .newsItem{
    .MD{
      display: none;
    }
  }
}
</style>
